export default __webpack_public_path__ + "static/media/Monger-HUD-Dock Icons.9679d89d.jpg";